export default __webpack_public_path__ + "static/media/patalkot.537c335a.jpg";